const t={xs:"text-xs",sm:"text-sm",md:"text-base",lg:"text-lg",xl:"text-xl",threeXl:"text-3xl"};export{t as fontSize};
